<template>
  <div id="Header" class="header-layout">
    <v-img
      class="image-logo"
      src="../assets/logo/gulf-logo.png"
      v-if="
        $route.name === 'page-login' || $route.name === 'page-forgotpassword'
      "
    ></v-img>
    <div
      class="menubar"
      v-if="
        $route.name === 'page-login' || $route.name === 'page-forgotpassword'
      "
    >
      <v-btn dark text :href="adminURL" target="_blank">
        <v-icon left>mdi-account-outline</v-icon>
        Admin
      </v-btn>

      <v-btn dark text href="https://www.gulf.co.th" target="_blank">
        <v-icon left>mdi-home-city-outline</v-icon>
        Gulf's Website
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    adminURL: process.env.VUE_APP_ADMIN_URL,
  }),
};
</script>

<style lang="scss" scoped>
.header-layout {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > .image {
    height: 100vh;
    position: fixed;
    top: 0;
  }
  > .image-logo {
    position: fixed;
    width: 150px;
    top: 3rem;
    left: 3rem;
  }
  > .image-auth {
    height: 100vh;
    width: 100vw;
  }
  > .menubar {
    position: fixed;
    top: 3rem;
    right: 3rem;
    display: flex;
    flex-direction: row;
  }
}
</style>
